/**
 * AĞAÇ İNSANI — model doğrulama örneği (Adım 1)
 *
 * Tetiklediği zor kısımlar:
 *   - ÖZEL AC TABANI: zırhsız AC = 13 + DEX (standart 10 değil)
 *   - 1/N seçim: Meşe / Söğüt / Çiçek-Meyve soyu (her biri farklı etki)
 *   - yuva harcamadan kullanılan büyü (Yeşil İyileşme) — ayrı kullanım sayacı
 *   - Thorn Whip cantrip'i (yetenek: Algı)
 *   - menzil artışı (Kadim Hafıza: Blindsight 30 ft)
 */

import type { RaceEntry } from '@tttrpg/rules'

export const AGAC_INSANI: RaceEntry = {
  id: 'agac-insani',
  name: 'Ağaç İnsanı',
  size: 'Orta',
  reach: 5,
  speed: 30,
  abilityBonuses: {},
  asiChoices: {},
  asi: 0,
  asiChoiceOptions: [],
  // ★ Zırh olmazken AC tabanı 13, standart değil.
  acBase: 13,
  darkvision: 0,
  cantrips: ['druidcraft'],
  feat: null,

  // Kök Sal / Yeşil İyileşme + Sarmaşık Eli seviye kapılı; 1. seviyede
  // kullanılabilir büyü havuzu boş.
  innateSpells: [],

  choices: [
    {
      id: 'agac-soyu',
      label: 'Tree Lineage',
      labelTr: 'Ağaç Soyu',
      description: 'Meşe, Söğüt veya Çiçek/Meyve soyu seç. Seçimin ek etkileri farklıdır.',
      min: 1,
      max: 1,
      options: [
        {
          id: 'meşe',
          name: 'Oak Lineage',
          nameTr: 'Meşe Soyu',
          description: 'Meşe soyu: dayanıklılık odaklı. +1 Dayanıklılık.',
          effects: { abilityBonuses: { con: 1 } },
        },
        {
          id: 'sögüt',
          name: 'Willow Lineage',
          nameTr: 'Söğüt Soyu',
          description: 'Söğüt soyu: hız odaklı. +10 ft hız.',
          effects: { speedBonus: 10 },
        },
        {
          id: 'çiçek-meyve',
          name: 'Blight Lineage',
          nameTr: 'Çiçek/Meyve Soyu',
          description: 'Çiçek/Meyve soyu: sihir odaklı. +1 Zekâ.',
          effects: { abilityBonuses: { int: 1 } },
        },
      ],
    },
  ],

  features: [
    {
      id: 'agac-kabuk-ve-soy',
      name: 'Kabuk ve Soy',
      grantedAtLevel: 1,
      description: 'Zırhsız AC = 13 + Çeviklik. Soy seç. Druidcraft büyüsü.',
    },
    {
      id: 'agac-kok-sal',
      name: 'Kök Sal',
      grantedAtLevel: 3,
      description:
        'Bonus eylem. Bir sonraki turun başlangıcına kadar: Hız 0, AC +1, yere yatık ve zorla hareket ettirilmeye karşı kazanç. Kullanım: PB / Uzun Dinlenme.',
      acBonus: 1,
      acBonusCap: 1,
    },
    {
      id: 'agac-yesil-iyilestirme',
      name: 'Yeşil İyileşme',
      grantedAtLevel: 5,
      description:
        'Eylem, güneş/su/toprak yakınında. Kendine veya bitki kökenli gönüllü yaratığa PB × d4 iyileşme. 1 / Uzun Dinlenme.',
      innateSpells: [
        {
          grantedAtLevel: 5,
          spellIds: ['green-healing'],
          uses: { count: 1, recharge: 'long' },
        },
      ],
    },
    {
      id: 'agac-sarmasik-eli',
      name: 'Sarmaşık Eli',
      grantedAtLevel: 5,
      description: 'Thorn Whip büyüsü. Büyü yeteneği: Algı.',
    },
    {
      id: 'agac-kok-agi',
      name: 'Kök Ağı',
      grantedAtLevel: 9,
      description:
        'Eylemle 20 ft yarıçapı 1 dakika köklerle kapla. Alan düşmanlar için zorlu arazi. İlk kez giren düşman Güç Kurtarma Atışı yapar. 1 / Uzun Dinlenme.',
    },
    {
      id: 'agac-koruluk-sifasi',
      name: 'Koruluk Şifası',
      grantedAtLevel: 13,
      description:
        'Yeşil İyileşme kullanımı 2 / Uzun Dinlenme olur ve 30 ft içindeki iki hedefe PB × d3 iyileştirme yapabilirsin.',
    },
    {
      id: 'agac-kadim-hafiza',
      name: 'Kadim Hafıza',
      grantedAtLevel: 17,
      description:
        'Toprağa kök salıp 10 dakika konsantre ol: bölgede yaşanmış önemli bir olaya ait bulanık anı. 1 / Uzun Dinlenme, Kök Sal ile 1 dakika Blindsight 30 ft.',
    },
  ],
}
